/* eslint-disable indent */
import React, { useState, useMemo, useEffect } from "react";

import { get } from "lodash";
import isEmpty from "lodash/isEmpty";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Input from "shared/components/Input";
import NextPreviousFooter from "shared/components/NextPreviousFooter";
import Product from "shared/components/Product";
import Space from "shared/components/Space";
import Spin from "shared/components/Spin";
import { StepStore } from "shared/components/Tab";
import { NAME_SPACES } from "shared/locals/constants";

import "./styles.scss";
import FoldersTitle from "../Common/FoldersTitle";
import { INTERVENTION } from "../constants";

const ProductDetails = ({
  query: { data, loading },
  product,
  onChange,
  setActiveStep,
  warranty,
  step: { changeTab, onBack },
}) => {
  const { t } = useTranslation(NAME_SPACES.NEW_FOLDER, {
    keyPrefix: "PRODUCT_DETAIL",
  });
  const rules = useMemo(
    () => get(data, "rules.data.masks[0].sn1info", {}),
    [data],
  );
  const rules2 = useMemo(
    () => get(data, "rules.data.masks[0].sn2info", {}),
    [data],
  );
  const [sn, setSn] = useState(product.sn || "");
  const [sn2, setSn2] = useState(product.sn2 || "");

  useEffect(() => {
    // if (!loading && isEmpty(rules) && isEmpty(rules2)) {
    //   setActiveStep(2);
    //   changeTab(INTERVENTION, "replace");
    // }
  }, [loading, rules, rules2]);

  return (
    <>
      <div className={"newfolder--wrapper--content"}>
        <FoldersTitle title={t("TITLE")} subTitle={t("SUB_TITLE")} />
        <div className={"newfolder--wrapper--content--search"}>
          <div className="warranty">
            {loading ? (
              <Spin />
            ) : (
              <>
                <p className="text">{warranty}</p>
              </>
            )}
          </div>
          <div className={"newfolder--wrapper--content--search--result"}>
            <Product items={[product]} type={"listProduct"} hideCheck />
            {loading && <Spin />}
            {!loading && (
              <>
                {!isEmpty(rules) && (
                  <Input
                    placeholder={t("SERIAL_1")}
                    value={sn}
                    onChange={(e) => {
                      setSn(e.target.value);
                    }}
                  />
                )}
                {(rules.mandatory ? sn.length === 0 : true) &&
                  !sn.match(rules.snMask) && (
                    <p className={"text-error"}>{rules.snMessage}</p>
                  )}
                <Space h={12} />
                {!isEmpty(rules2) && (
                  <Input
                    placeholder={t("SERIAL_2")}
                    value={sn2}
                    onChange={(e) => {
                      setSn2(e.target.value);
                    }}
                  />
                )}
                {(rules2.mandatory ? sn2.length === 0 : true) &&
                  !sn2.match(rules2.snMask) && (
                    <p className={"text-error"}>{rules2.snMessage}</p>
                  )}
              </>
            )}
          </div>
        </div>
      </div>
      <NextPreviousFooter
        onPreviousClick={() => {
          onBack();
        }}
        nextEnabled={
          (rules.mandatory ? sn.length > 0 : true) &&
          sn.match(rules.snMask) &&
          (rules2.mandatory ? sn2.length > 0 : true) &&
          sn2.match(rules2.snMask)
        }
        previousEnabled={true}
        onNextClick={() => {
          onChange({ sn, sn2 });
          setActiveStep(2);
          changeTab(INTERVENTION);
        }}
      />
    </>
  );
};

ProductDetails.propTypes = {
  query: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    data: PropTypes.shape({
      rules: PropTypes.shape({
        masks: PropTypes.array,
      }),
    }),
  }).isRequired,
  warranty: PropTypes.string.isRequired,
  product: PropTypes.shape({
    sn: PropTypes.string,
    sn2: PropTypes.string,
  }).isRequired,
  setActiveStep: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  step: PropTypes.shape({
    changeTab: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
  }).isRequired,
};

ProductDetails.defaultProps = {};
export default StepStore(ProductDetails);
